export const getModuleColor = (moduleName) => {
    switch (moduleName) {
        case "CORE": return "#2bb673"
        case "ADMIN": return "orange"
        case "HR": return "gold"
        case "WHISTLE": return "orange"
        case "HEALTH": return "lightgreen"
        case "SAFETY": return "tomato"
        case "AI": return "#d731a3"
        case "DEVICES": return "#64b5f6"
        case "ATTENDANCE": return "#a5d6a7"
        case "DOMUS": return "#4dd0e1"
        default: return "#FFFFFF"
    }
}